import { useEffect, useRef, useState, useCallback } from "react";

const testimonials = [
  {
    name: "林小姐",
    role: "台北 · 設計師",
    rating: 5,
    date: "2024.11",
    product: "九眼天珠手鍊",
    content: "在瓏靖找到了一條九眼天珠手鍊，戴上後感覺整個人的狀態都不一樣了。不只是飾品，更像是一份來自遠方的祝福，陪伴著我度過每一天。",
    img: "https://readdy.ai/api/search-image?query=elegant%20asian%20woman%20portrait%20soft%20natural%20light%20warm%20tones%20lifestyle%20photography%20minimalist%20background%20serene%20peaceful%20expression%20high%20quality&width=400&height=500&seq=test001&orientation=portrait",
  },
  {
    name: "陳先生",
    role: "高雄 · 企業主",
    rating: 5,
    date: "2024.10",
    product: "翡翠平安扣吊墜",
    content: "送給太太的翡翠玉石吊墜，她非常喜歡。瓏靖的商品質感真的很高，包裝也很精緻，作為禮物送出去非常有面子，對方也感受到了那份心意。",
    img: "https://readdy.ai/api/search-image?query=elegant%20asian%20man%20portrait%20soft%20natural%20light%20warm%20tones%20lifestyle%20photography%20minimalist%20background%20serene%20confident%20expression%20high%20quality&width=400&height=500&seq=test002&orientation=portrait",
  },
  {
    name: "王小姐",
    role: "台中 · 瑜伽老師",
    rating: 5,
    date: "2024.09",
    product: "天然紫水晶手鍊",
    content: "我對能量飾品很挑剔，但瓏靖的水晶讓我一眼就喜歡上了。不只是外觀美，更重要的是那種拿在手上的踏實感，感覺真的有在守護著我。",
    img: "https://readdy.ai/api/search-image?query=elegant%20asian%20woman%20yoga%20teacher%20portrait%20soft%20natural%20light%20warm%20tones%20lifestyle%20photography%20minimalist%20background%20calm%20peaceful%20expression%20high%20quality&width=400&height=500&seq=test003&orientation=portrait",
  },
  {
    name: "張先生",
    role: "新竹 · 工程師",
    rating: 5,
    date: "2024.08",
    product: "手繪唐卡 — 財神",
    content: "買了財神唐卡放在辦公室，同事都說氣場變好了！瓏靖的服務態度非常好，還幫我解說了唐卡的文化意涵，讓我更了解這件藝術品的價值。",
    img: "https://readdy.ai/api/search-image?query=elegant%20asian%20man%20engineer%20portrait%20soft%20natural%20light%20warm%20tones%20lifestyle%20photography%20minimalist%20background%20confident%20professional%20expression%20high%20quality&width=400&height=500&seq=test004&orientation=portrait",
  },
  {
    name: "李小姐",
    role: "台南 · 老師",
    rating: 5,
    date: "2024.07",
    product: "金髮晶招財手鍊",
    content: "金髮晶手鍊真的很漂亮，在陽光下閃閃發光。瓏靖的品質讓我非常放心，每一顆珠子都很均勻，做工精細，戴了之後收到很多稱讚！",
    img: "https://readdy.ai/api/search-image?query=elegant%20asian%20woman%20teacher%20portrait%20soft%20natural%20light%20warm%20tones%20lifestyle%20photography%20minimalist%20background%20gentle%20kind%20expression%20high%20quality&width=400&height=500&seq=test005&orientation=portrait",
  },
];

export default function Testimonials() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [direction, setDirection] = useState<"next" | "prev">("next");
  const [isPaused, setIsPaused] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const goTo = useCallback((index: number, dir: "next" | "prev") => {
    if (isAnimating) return;
    setDirection(dir);
    setIsAnimating(true);
    setTimeout(() => {
      setActiveIndex(index);
      setIsAnimating(false);
    }, 400);
  }, [isAnimating]);

  const goNext = useCallback(() => {
    const next = (activeIndex + 1) % testimonials.length;
    goTo(next, "next");
  }, [activeIndex, goTo]);

  const goPrev = useCallback(() => {
    const prev = (activeIndex - 1 + testimonials.length) % testimonials.length;
    goTo(prev, "prev");
  }, [activeIndex, goTo]);

  useEffect(() => {
    if (isPaused) return;
    timerRef.current = setInterval(goNext, 5000);
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [goNext, isPaused]);

  const active = testimonials[activeIndex];

  return (
    <section
      id="testimonials"
      className="py-28 md:py-36 bg-[#f5f0e8] overflow-hidden"
      ref={ref}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-10 h-px bg-[#8b6f47]"></span>
            <span
              className="text-[#8b6f47] text-[1rem] tracking-[0.3em] font-medium"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              STORIES
            </span>
            <span className="w-10 h-px bg-[#8b6f47]"></span>
          </div>
          <h2
            className="text-[#2d2520] font-bold mb-4 leading-[1.4]"
            style={{
              fontSize: "clamp(1.5rem, 3vw, 2.125rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            有緣人的故事
          </h2>
          <p
            className="text-[#7a6a5a] max-w-xl mx-auto leading-[1.75]"
            style={{ fontSize: "1.1875rem", fontFamily: "'Noto Serif TC', serif" }}
          >
            每一件能量飾品都陪伴著不同的人生故事，許多朋友在瓏靖找到屬於自己的守護與祝福。
          </p>
        </div>

        {/* Main Carousel */}
        <div
          className={`transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="relative">
            {/* Main Card */}
            <div className="bg-[#1e1a16] rounded-3xl overflow-hidden">
              <div className="grid grid-cols-1 md:grid-cols-2">
                {/* Image */}
                <div className="relative h-80 md:h-[520px] overflow-hidden">
                  <img
                    key={`img-${activeIndex}`}
                    src={active.img}
                    alt={active.name}
                    className={`w-full h-full object-cover object-top transition-all duration-500 ${
                      isAnimating
                        ? direction === "next"
                          ? "opacity-0 scale-105"
                          : "opacity-0 scale-95"
                        : "opacity-100 scale-100"
                    }`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#1e1a16]/40 hidden md:block"></div>
                  {/* Product Tag */}
                  <div className="absolute bottom-5 left-5">
                    <span
                      className="px-4 py-2 bg-[#c9a96e]/90 backdrop-blur-sm text-[#1e1a16] text-[0.9375rem] rounded-full font-semibold"
                      style={{ fontFamily: "'Noto Serif TC', serif" }}
                    >
                      {active.product}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-10 md:p-14 flex flex-col justify-between">
                  <div>
                    {/* Stars */}
                    <div className="flex items-center gap-1 mb-6">
                      {Array.from({ length: active.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-[#c9a96e] text-xl"></i>
                      ))}
                    </div>

                    <div
                      className="text-[#c9a96e] mb-4"
                      style={{ fontSize: "3.5rem", lineHeight: 1, fontFamily: "Georgia, serif" }}
                    >
                      &ldquo;
                    </div>
                    <p
                      key={`content-${activeIndex}`}
                      className={`text-white leading-[1.85] mb-8 transition-all duration-400 ${
                        isAnimating ? "opacity-0 translate-y-3" : "opacity-100 translate-y-0"
                      }`}
                      style={{ fontSize: "1.1875rem", fontFamily: "'Noto Serif TC', serif" }}
                    >
                      {active.content}
                    </p>
                  </div>

                  <div>
                    <div className="flex items-center gap-4 mb-8">
                      <img
                        src={active.img}
                        alt={active.name}
                        className="w-12 h-12 rounded-full object-cover object-top flex-shrink-0"
                      />
                      <div>
                        <p
                          className="text-white font-semibold text-[1.125rem]"
                          style={{ fontFamily: "'Noto Serif TC', serif" }}
                        >
                          {active.name}
                        </p>
                        <p
                          className="text-white/50 text-[0.9375rem]"
                          style={{ fontFamily: "'Noto Serif TC', serif" }}
                        >
                          {active.role} · {active.date}
                        </p>
                      </div>
                    </div>

                    {/* Controls */}
                    <div className="flex items-center justify-between">
                      {/* Dots */}
                      <div className="flex items-center gap-2.5">
                        {testimonials.map((_, i) => (
                          <button
                            key={i}
                            onClick={() => goTo(i, i > activeIndex ? "next" : "prev")}
                            className={`rounded-full transition-all duration-300 cursor-pointer ${
                              i === activeIndex
                                ? "w-8 h-2 bg-[#c9a96e]"
                                : "w-2 h-2 bg-white/25 hover:bg-white/50"
                            }`}
                          />
                        ))}
                      </div>

                      {/* Arrow Buttons */}
                      <div className="flex items-center gap-3">
                        <button
                          onClick={goPrev}
                          className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:border-[#c9a96e] hover:text-[#c9a96e] transition-all duration-300 cursor-pointer"
                        >
                          <i className="ri-arrow-left-line text-lg"></i>
                        </button>
                        <button
                          onClick={goNext}
                          className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:border-[#c9a96e] hover:text-[#c9a96e] transition-all duration-300 cursor-pointer"
                        >
                          <i className="ri-arrow-right-line text-lg"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="mt-4 h-0.5 bg-[#e8e0d5] rounded-full overflow-hidden">
              <div
                key={`progress-${activeIndex}-${isPaused}`}
                className="h-full bg-[#8b6f47] rounded-full"
                style={{
                  animation: isPaused ? "none" : "progressBar 5s linear forwards",
                  width: isPaused ? `${((activeIndex + 1) / testimonials.length) * 100}%` : "0%",
                }}
              />
            </div>
          </div>

          {/* Thumbnail Strip */}
          <div className="mt-8 grid grid-cols-5 gap-3">
            {testimonials.map((t, i) => (
              <button
                key={i}
                onClick={() => goTo(i, i > activeIndex ? "next" : "prev")}
                className={`relative rounded-xl overflow-hidden cursor-pointer transition-all duration-300 ${
                  i === activeIndex
                    ? "ring-2 ring-[#c9a96e] ring-offset-2 ring-offset-[#f5f0e8]"
                    : "opacity-50 hover:opacity-80"
                }`}
              >
                <div className="aspect-square">
                  <img
                    src={t.img}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute inset-0 bg-[#1e1a16]/30"></div>
                <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-[#1e1a16]/80 to-transparent">
                  <p
                    className="text-white text-[0.75rem] font-medium truncate"
                    style={{ fontFamily: "'Noto Serif TC', serif" }}
                  >
                    {t.name}
                  </p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes progressBar {
          from { width: 0%; }
          to { width: 100%; }
        }
      `}</style>
    </section>
  );
}
